export enum SituacaoParcela {
  AVencer = 'A vencer',
  Cancelado = 'Cancelado',
  Negativado = 'Negativado',
  Pago = 'Pago',
  Renegociado = 'Renegociado',
  Vencido = 'Vencido',
  AguardandoPagamentoAutomatico = 'Aguardando pagamento automático',
  AguardandoPagamentoAgendado = 'Aguardando pagamento agendado',
  Reembolso = 'Reembolso'
}

export enum SituacaoParcelaFiltro {
  AVencer = 'AVencer',
  Cancelado = 'Cancelado',
  Negativado = 'Negativado',
  Pago = 'Pago',
  Renegociado = 'Renegociado',
  Vencido = 'Vencido',
  AguardandoPagamentoAutomatico = 'AguardandoPagamentoAutomatico',
  AguardandoPagamentoAgendado = 'AguardandoPagamentoAgendado',
  Reembolso = 'Reembolso'
}
